import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'One' },
    { value: 2, label: 'Two' },
    { value: 3, label: 'Three' },
    { value: 4, label: 'Four' },
    { value: 5, label: 'Five' },
  ],
});
